import { useMemo } from 'react';
import { getShouldDisableEmployeeReferralStates } from '~/growthbook';
import { useUserSelector } from '~/hooks';
import { useIsParentOfficeSelector } from '~/hooks/useIsParentOfficeSelector';

export const useIsReferralProgramVisible = () => {
  const user = useUserSelector();
  const isParentOffice = useIsParentOfficeSelector();
  const statesToDisableReferralProgram = getShouldDisableEmployeeReferralStates();
  const isReferralScreenDisabledState = statesToDisableReferralProgram?.includes(
    user?.address?.[0]?.state,
  );

  const shouldShowReferralProgram = useMemo(() => {
    if (isReferralScreenDisabledState || isParentOffice) {
      return false;
    }

    return true;
  }, [isParentOffice, isReferralScreenDisabledState]);

  return shouldShowReferralProgram;
};
